// eve-chat-mode-store — V1 App.js Z.185 `chatMode`-Toggle in Zustand-Form.
//
//   - 'trading' = Default (📊). Voller Markt-Brain (getEveBrain), LIVE_DATA,
//     EXECUTION_DIRECTIVE, EVE_CALL-Pflicht. So „arbeitet" EVE.
//   - 'private' = Plauder-Modus (💬). EVE_PRIVATE_BRAIN, kein Markt-Kontext.
//     Bei Trade-Frage schaltet die Runtime zurück auf den Markt-Brain mit
//     TRADING_DIRECTIVE (V1 App.js Z.1112).
//
// Persistiert, damit der Toggle Reload-fest ist.

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { ChatMode } from '@/services/eve-runtime';

export const EVE_CHAT_MODE_STORE_KEY = 'eve_chat_mode_v3';

export interface EveChatModeState {
  mode: ChatMode;
  setMode: (mode: ChatMode) => void;
  toggle: () => void;
}

export const useEveChatModeStore = create<EveChatModeState>()(
  persist(
    (set) => ({
      mode: 'trading',
      setMode: (mode) => set({ mode }),
      toggle: () =>
        set((s) => ({ mode: s.mode === 'trading' ? 'private' : 'trading' })),
    }),
    {
      name: EVE_CHAT_MODE_STORE_KEY,
      storage: createJSONStorage(() => localStorage),
      version: 1,
    },
  ),
);

export const selectChatMode = (s: EveChatModeState): ChatMode => s.mode;
